import { Observable, fromEvent, merge } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CookieFirstWindowEvent, isCookieCategories, isCookieServices } from '../types';
import { CookieBannerEvents, CookieFirstEvents } from '../actions';

export function cookieBannerConsentEpic(): Observable<any> {
    return merge(
        /**
         * Listen for the Cookie Banner consent events.
         * This will emit a list of categories that the user has consented to.
         */
        fromEvent(window, CookieFirstEvents.CONSENT).pipe(
            map((event) => {
                const categories = (event as CookieFirstWindowEvent)?.detail || {};

                if (typeof categories !== 'object' || !isCookieCategories(categories)) {
                    return null;
                }

                return {
                    type: CookieBannerEvents.CONSENT,
                    payload: categories,
                };
            }),
            filter(Boolean),
        ),

        /**
         * Listen for the Cookie Banner consent services events.
         * This will emit a list of services (as identified by CookieFirst)
         * that the user has consented to.
         */
        fromEvent(window, CookieFirstEvents.CONSENT_SERVICES).pipe(
            map((event) => {
                const services = (event as CookieFirstWindowEvent)?.detail || {};

                if (typeof services !== 'object' || !isCookieServices(services)) {
                    return null;
                }

                return {
                    type: CookieBannerEvents.CONSENT_SERVICES,
                    payload: services,
                };
            }),
            filter(Boolean),
        ),
    );
}
